import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
// import userReducer from './features/user';
import loginReducer from './features/login';
import firstLoginCategoryFormReducer from './features/firstLoginCategoryForm'
import userIsLogInReducer from './features/userIsLogIn'
import chooseCategoryReducer from './features/chooseCategory';

const store = configureStore({
  reducer: {
    // user: userReducer,
    login: loginReducer,
    firstLoginCategoryForm: firstLoginCategoryFormReducer,
    userIsLogIn: userIsLogInReducer,
    chooseCategory: chooseCategoryReducer
  },
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
